import React, { useMemo } from 'react';
import { Column } from 'devextreme-react/data-grid';
import { GroupItem, SimpleItem, Label } from "devextreme-react/form";
import IPublicite from "../../models/IPublicite";
import GestionAbstract from '../../components/forms/gestion-abstract';
import Guid from '../../models/Guid';
import IBaseModel from '../../models/IBaseModel';

interface IGestionPubliciteProps {
  isModeSelection?: boolean,
}

class Publicite extends IBaseModel implements IPublicite {
  idPublicite: Guid = Guid.empty;
  descriptionAnglais: string = '';
  afficherEnLigne: boolean = false;
}

export default function GestionPublicite({ isModeSelection }: IGestionPubliciteProps) {
  const afficherEnLigneOptions = useMemo(() => {
    return { text: "Afficher en ligne" };
  }, []);

  const descriptionAnglaisOptions = useMemo(() => {
    return { maxLength: 100 };
  }, []);

  const descriptionEditorOptions = useMemo(() => {
    return { maxLength: 50 }
  }, []);

  return (
    <GestionAbstract<IPublicite>
      isModeSelection={isModeSelection}
      path="Publicite"
      model={Publicite}
      additionalColumns={
        <>
          <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
          <Column key={"grid-col-description-anglais"} dataField={"descriptionAnglais"} caption="Description anglaise" allowHiding={false} />
        </>
      }
      customFormItems={(selectedPublicite) => (
        <GroupItem>
          <SimpleItem key={"frm-description"} dataField={"description"} editorOptions={descriptionEditorOptions}>
            <Label text={"Description"} showColon={false} />
          </SimpleItem>
          <SimpleItem key={"frm-description-anglais"} dataField={"descriptionAnglais"} editorOptions={descriptionAnglaisOptions}>
            <Label text={'Description anglaise'} />
          </SimpleItem>
          <SimpleItem key={"frm-afficher-en-ligne"} dataField={"afficherEnLigne"} editorType={"dxCheckBox"}
            editorOptions={afficherEnLigneOptions}
          >
            <Label visible={false} />
          </SimpleItem>
        </GroupItem>
      )}
    />
  );
}